import React, { useState, useEffect } from 'react'
import { Link } from 'gatsby'
import { useStore } from '../../lib/context'

import { observer } from 'mobx-react-lite'
import { motion } from 'framer-motion'
import css from 'styled-jsx/css'

const Carrot = observer(() => {
	const {
		uiStore: { directory__mobileMenuOpen },
	} = useStore()
	return (
		<div className="carrot">
			<svg
				width="15px"
				height="9px"
				viewBox="0 0 15 9"
				version="1.1"
				xmlns="http://www.w3.org/2000/svg"
			>
				<g
					id="Page-1"
					stroke="none"
					stroke-width="1"
					fill="none"
					fill-rule="evenodd"
					opacity="0.5"
					stroke-linecap="round"
					stroke-linejoin="bevel"
				>
					<path
						d="M11.2370705,-1.95230667 L4.64902868,3.48616082 C4.32656246,3.74834322 4.12786177,4.132984 4.10065407,4.54769333 C4.12486833,4.96252626 4.3242269,5.34752606 4.64902868,5.60671035 L11.2370705,11.0476933"
						id="Path-Copy-4"
						stroke="#000000"
						stroke-width="1.5"
						transform="translate(7.668862, 4.547693) scale(1, -1) rotate(90.000000) translate(-7.668862, -4.547693) "
					></path>
				</g>
			</svg>
			<style jsx>{`
				@media only screen and (max-width: 768px), (pointer: coarse) {
					.carrot {
						height: var(--nav-bar-height-mobile);
						display: flex;
						align-items: center;
						transition-duration: 0.5s;
						transform-origin: center center;
						-webkit-transform: rotateX(
							${directory__mobileMenuOpen ? '180deg' : '0deg'}
						);
						transform: rotateX(
							${directory__mobileMenuOpen ? '180deg' : '0deg'}
						);
					}
				}
			`}</style>
		</div>
	)
})

export default Carrot
